<template>
  <AppDialog
    is-open
    :cancel-text="t(`${TRANSLATION_KEY_PREFIX}.continue`)"
    :ok-text="t(`${TRANSLATION_KEY_PREFIX}.discard`)"
    @cancel="onContinueEditing"
    @ok="onDiscard"
  >
    <template #title>
      <span class="dialog-title">{{ t(`${TRANSLATION_KEY_PREFIX}.title`) }}</span>
    </template>

    <template #body>
      <p class="dialog-body my-2">{{ t(`${TRANSLATION_KEY_PREFIX}.body`) }}</p>
    </template>
  </AppDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import AppDialog from '@/common/dialogs/AppDialog.vue'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantDraftDeletionDialog'

export default defineComponent({
  name: 'AIAssistantDraftDeletionDialog',
  emits: ['discard', 'continue-editing'],
  components: {
    AppDialog,
  },
  setup () {
    const { t } = useI18n()
    return { t, TRANSLATION_KEY_PREFIX }
  },
  methods: {
    onDiscard () {
      this.$emit('discard')
    },
    onContinueEditing () {
      this.$emit('continue-editing')
    },
  },
})
</script>

<style scoped>
.dialog-body {
  line-height: 20px;
  color: rgb(var(--v-theme-grey-darken-3));
}

.dialog-title {
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.15px;
  color: rgb(var(--v-theme-grey-darken-4));
}
</style>
